<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-flex align-items-start justify-content-between p-15 p-sm-20 p-md-25 gap-3 flex-wrap">
            <div class="d-sm-flex align-items-center">
        <router-link to="/create-survey"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
          {{ $t('cta.create_survey') }}
          <i class="ph-bold ph-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <SpinnerLoading v-if="surveys === undefined || surveys === null" class="mt-50" />
            <div class="table-responsive" v-else>
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                               ID
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.name.label').toUpperCase() }}
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.key.label').toUpperCase() }}
                            </th>
                            
                            <th scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                            </th>
                        </tr>
                    </thead>
                    <tbody class="linked">
                        <!-- PATIENT ROW -->
                        <tr v-for="survey in (surveys! as PatientInfo[])" :key="survey!.id">
                            <th class="shadow-none lh-1 fw-medium text-primary" @click="show(survey)">
                                {{ survey.id }}
                            </th>
                            <th class="shadow-none lh-1 fw-medium text-black-emphasis title" @click="show(survey)">
                                {{ survey.title }}
                            </th>
                            <td class="shadow-none lh-1 fw-medium text-body-tertiary" @click="show(survey)">
                                {{ survey.key }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end"
                                >
                                <div class="dropdown position-static">
                                    <button
                                        class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                                        type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                        data-bs-boundary="viewport">
                                        <i class="flaticon-dots"></i>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li >
                                            <router-link :to="{ path: `/survey/${survey.id}/edit` }"
                                                class="dropdown-item d-flex align-items-center">
                                                <i class="ph-duotone ph-pencil lh-1 me-8 position-relative top-1"></i>
                                                {{ $t('cta.edit') }}
                                            </router-link>
                                        </li>
                                        <li>
                                            <button class="dropdown-item d-flex align-items-center"
                                                v-on:click="confirmDeleteSurvey(survey)">
                                                <i class="ph ph-trash lh-1 me-8 position-relative top-1"></i>
                                                {{ $t('cta.delete') }}
                                            </button>
                                        </li>
                                    </ul>

                                </div>
                            </td>
                        </tr>
                        <!--  -->
                    </tbody>
                </table>
            </div>
            <!-- PAGINATION -->
            <TablePagination :count="surveys?.length ?? 0" :page="currentPage" :total="totalSurveys" :pages="lastPage"
                @change="setPage($event)" />
        </div>
    </div>
    <ConfirmModal @confirm="deleteSurvey()" :title="$t('cta.$delete.title')" :message="$t('cta.$delete.message')" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ConfirmModal from "@/components/Widgets/ConfirmModal.vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { Modal } from "bootstrap";
import { CenterWithPermission, PatientInfo } from "@/utils/models/user.model";
import { Survey } from "@/utils/models/survey.model";
import API from "@/services/api/api.service";
import DateFormatUtils from "@/utils/methods/date_formats";
import stateStore from "@/utils/store";
import { PermissionAction } from "@/utils/const/permission_actions";
import TablePagination from "@/components/FK/TablePagination.vue";

export default defineComponent({
    name: "SurveyList",
    data() {
        return {
            surveys: undefined,
            currentPage: 1,
            totalSurveys: 0,
            lastPage: 1,
            confirmModal: null,
            selectedSurvey: null,
            pageSize: 0,
        } as {
            surveys?: Survey[],
            currentPage: number,
            lastPage: number,
            pageSize: number,
            totalSurveys: number,
            confirmModal: Modal | null,
            selectedSurvey: PatientInfo | null;
        }
    },
    mounted() {
        var queryIndex = parseInt(this.$route.query.page as string ?? '1');
        if (queryIndex > 0) {
            this.currentPage = queryIndex;
        }
        this.loadSurveys(this.currentPage);
        this.confirmModal = new Modal('#confirmModal', {})
    },
    computed: {
        storeEnabled() { return stateStore.getPermisison('store') },
    },
    methods: {
        loadSurveys(page: number) {
            this.surveys = undefined;
            API.getSurveys({ page: page, load_steps: false }).then((res) => {
                this.surveys = res.data.data;
                this.totalSurveys = res.data.total;
                this.lastPage = res.data.last_page;
                this.pageSize = res.data.per_page;
            })
        },
        setPage(page: number) {
            this.currentPage = page;
            this.$router.replace({ query: { page: this.currentPage } });
            this.loadSurveys(page);
        },
        confirmDeleteSurvey(survey: PatientInfo) {
            this.selectedSurvey = survey;
            this.$data.confirmModal?.show();
        },
        deleteSurvey(): void {
            API.deleteSurvey(this.selectedSurvey?.id!).then((response) => {
                if (response.data.success === true) {
                    this.selectedSurvey = null;
                    this.setPage(1);
                }
            }).finally(() => {
                console.log("DELETED_PATIENT_ID", this.selectedSurvey?.id);
            })
        },
        formatDate(date: Date) {
            return DateFormatUtils.YYYYMMDD(date);
        },
        show(survey: Survey) {
            this.$router.push({ path: `/survey/${survey.id}/edit` });
        },
    },
    components: {
        ConfirmModal,
        SpinnerLoading,
        TablePagination
    },
});
</script>